import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProjectListPage from "./components/company/projects/pages/index/ProjectListPage";
import ProjectsCreateForm from "./components/company/projects/pages/create/ProjectsCreateForm";
import ProjectDetailPage from "./components/company/projects/pages/show/ProjectDetailPage";
import ProjectEditForm from "./components/company/projects/pages/edit/ProjectEditForm";
import JobListPage from "./components/company/jobs/pages/index/JobListPage";
import JobsCreateForm from "./components/company/jobs/pages/create/JobsCreateForm";
import JobDetailPage from "./components/company/jobs/pages/show/JobDetailPage";
import JobEditForm from "./components/company/jobs/pages/edit/JobEditForm";
import ProjectLayout from "./components/user/projects/ProjectLayout";
import UserProjectListPage from "./components/user/projects/pages/index/ProjectListPage";
import UserProjectDetailPage from "./components/user/projects/pages/show/ProjectDetailPage";
import JobLayout from "./components/user/jobs/JobLayout";
import UserJobListPage from "./components/user/jobs/pages/index/JobListPage";
import UserJobDetailPage from "./components/user/jobs/pages/show/JobDetailPage";
import CompanyCandidatesListPage from "./components/company/candidates/pages/index/CompanyCandidatesListPage";
import CompanyUserContractRequestPage from "./components/company/candidates/pages/show/CompanyUserContractRequestPage";
import CompanyUserJobRequestPage from "./components/company/candidates/pages/show/CompanyUserJobRequestPage";
import MemberListPage from "./components/company/members/pages/index/MemberListPage";
import CompanyMypage from "./components/company/mypage/Mypage";
import CompanyInfo from "./components/company/info/CompanyInfo";
import CompanyUsers from "./components/company/users/CompanyUsers";
import SettingEditForm from "./components/company/settings/pages/edit/SettingEditForm";
import ProjectRequestEdit from "./components/user_contract_request/pages/ProjectRequestEdit";
import JobRequestEdit from "./components/user_job_request/pages/JobRequestEdit";
import UserMyPage from "./components/mypage/MyPage";
import Layout from "./components/shared/layouts/Layout";
import SkillSheetCreateStepper from "./components/skill_sheet_basic/pages/create/SkillSheetCreateStepper";
import SkillSheetEditStepper from "./components/skill_sheet_basic/pages/edit/SkillSheetEditStepper";
import SkillSheetMainCreateStepper from "./components/skill_sheet_main/pages/create/SkillSheetMainCreateStepper";
import SkillSheetMainEditStepper from "./components/skill_sheet_main/pages/edit/SkillSheetMainEditStepper";
import ScrollToTop from "./components/shared/ScrollToTop";
import SelfEvaluationsEdit from "./components/self_evaluations/pages/SelfEvaluationsEdit";
import WithdrawalPage from "./components/withdrawal/WithdrawalPage";

// React Router を使ってルーティングを定義するコンポーネント
const AppRouter = ({
  flashMessage,
  currentUser,
  csrfToken,
  currentCompanyUser,
  userJobRequestExists,
  withdrawalAuthType,
  withdrawalProvider,
}) => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      {/* --- 企業側ルート --- */}
      <Route element={<Layout currentUser={currentUser} currentCompanyUser={currentCompanyUser} userJobRequestExists={userJobRequestExists}/>}>
        {/* 会社情報 */}
        <Route path="/mypage" element={<CompanyMypage />}>
          <Route index element={<CompanyInfo csrfToken={csrfToken} />} />
        </Route>

        {/* 担当者 */}
        <Route path="/company/users" element={<CompanyMypage />}>
          <Route index element={<CompanyUsers currentCompanyUser={currentCompanyUser} />} />
        </Route>

        {/* 設定 */}
        <Route path="/company/settings/edit" element={<CompanyMypage />}>
          <Route index element={<SettingEditForm />} />
        </Route>

        {/* プロジェクト */}
        <Route path="/company/projects" element={<CompanyMypage />}>
          <Route index element={<ProjectListPage />} />
          <Route path="new" element={<ProjectsCreateForm currentCompanyUser={currentCompanyUser} csrfToken={csrfToken} />} />
          <Route path=":id" element={<ProjectDetailPage />} />
          <Route path=":id/edit" element={<ProjectEditForm currentCompanyUser={currentCompanyUser} csrfToken={csrfToken} />} />
        </Route>

        {/* 求人 */}
        <Route path="/company/jobs" element={<CompanyMypage />}>
          <Route index element={<JobListPage />} />
          <Route path="new" element={<JobsCreateForm currentCompanyUser={currentCompanyUser} csrfToken={csrfToken} />} />
          <Route path=":id" element={<JobDetailPage />} />
          <Route path=":id/edit" element={<JobEditForm currentCompanyUser={currentCompanyUser} csrfToken={csrfToken} />} />
        </Route>

        {/* 人材・候補者 */}
        <Route path="/company/candidates" element={<CompanyMypage />}>
          <Route index element={<CompanyCandidatesListPage />} />
          <Route path=":id/contract_request" element={<CompanyUserContractRequestPage />} />
          <Route path=":id/job_request" element={<CompanyUserJobRequestPage />} />
          <Route path=":id/skill_sheet" element={<UserMyPage />} />
        </Route>

        {/* メンバー管理 */}
        <Route path="/company/members" element={<CompanyMypage />}>
          <Route index element={<MemberListPage flashMessage={flashMessage} currentCompanyUser={currentCompanyUser} />} />
          <Route path=":id/skill_sheet" element={<UserMyPage />} />
          <Route path=":id/skill_sheet_basics/edit" element={<SkillSheetEditStepper csrfToken={csrfToken} />} />
          <Route path=":id/skill_sheet_self_evaluations/edit" element={<SelfEvaluationsEdit />} />
          <Route path=":id/skill_sheet_mains/new" element={<SkillSheetMainCreateStepper csrfToken={csrfToken} />} />
          <Route path=":id/skill_sheet_mains/:id/edit" element={<SkillSheetMainEditStepper csrfToken={csrfToken} />} />
        </Route>

        {/* --- ユーザー側ルート --- */}
        <Route path="/skill_sheets" element={<UserMyPage currentUser={currentUser}/>} />
        <Route path="/skill_sheet_basics/new" element={<SkillSheetCreateStepper csrfToken={csrfToken} />} />
        <Route path="/skill_sheet_basics/edit" element={<SkillSheetEditStepper csrfToken={csrfToken} />} />
        <Route path="/skill_sheet_self_evaluations/edit" element={<SelfEvaluationsEdit />} />
        <Route path="/skill_sheet_mains/new" element={<SkillSheetMainCreateStepper csrfToken={csrfToken} />} />
        <Route path="/skill_sheet_mains/:id/edit" element={<SkillSheetMainEditStepper csrfToken={csrfToken} />} />
        
        <Route path="/projects" element={<ProjectLayout />}>
          <Route index element={<UserProjectListPage />} />
          <Route path=":id" element={<UserProjectDetailPage csrfToken={csrfToken} />} />
        </Route>

        <Route path="user_contract_request/edit" element={<ProjectRequestEdit csrfToken={csrfToken} />} />

        <Route path="/jobs" element={<JobLayout />}>
          <Route index element={<UserJobListPage  />} />
          <Route path=":id" element={<UserJobDetailPage csrfToken={csrfToken} />} />
        </Route>

        <Route path="user_job_request/edit" element={<JobRequestEdit csrfToken={csrfToken} />} />

        <Route
          path="/withdrawal"
          element={
            <WithdrawalPage
              csrfToken={csrfToken}
              withdrawalAuthType={withdrawalAuthType}
              withdrawalProvider={withdrawalProvider}
            />
          }
        />

        <Route path="/user_show/:id" element={<UserMyPage />} />
      </Route>
    </Routes>
  </BrowserRouter>
);


export default AppRouter;
